class RacedayAddFormController {
  constructor() {
  }
}

export default RacedayAddFormController;
